export default {
  firebase: {
    apiKey: "AIzaSyCkJ6L0aWjjCTTWsD64JdvaHo1eCD-5QQY",
    authDomain: "natracker-prod-fb6da.firebaseapp.com",
    databaseURL: "https://natracker-prod-fb6da.firebaseio.com",
    projectId: "natracker-prod-fb6da",
    storageBucket: "natracker-prod-fb6da.appspot.com"
  }
}